import HOME_PAGE_DATA from './home';
import DIGITIZE_PAGE_DATA from './digitize';
import TAPE_TRANSFER_PAGE_DATA from './tape-transfer';
import PHOTO_SCAN_PAGE_DATA from './photo-scan';
import FILM_TRANSFER_PAGE_DATA from './film-transfer';
import AUDIO_TRANSFER_PAGE_DATA from './audio-transfer';
import DIGITAL_TRANSFER_PAGE_DATA from './digital-transfer';
import VHS_PAGE_DATA from './vhs';
import VHS_C_PAGE_DATA from './vhs-c';
import HI8_PAGE_DATA from './hi8';
import MINI_DV_PAGE_DATA from './mini-dv';
import BETAMAX_PAGE_DATA from './betamax';
import PRO_FORMAT_PAGE_DATA from './pro-format';
import LOOSE_PHOTOS_PAGE_DATA from './loose-photos';
import SLIDES_PAGE_DATA from './slides';
import NEGATIVES_PAGE_DATA from './negatives';
import PHOTO_ALBUMS_PAGE_DATA from './photo-albums';
import DOCUMENT_SCANNING_PAGE_DATA from './document-scanning';
import FILM_8MM_PAGE_DATA from './film-8mm';
import FILM_SUPER_8MM_PAGE_DATA from './film-super-8mm';
import FILM_16MM_PAGE_DATA from './film-16mm';

const PAGES_DATA = {
  home: HOME_PAGE_DATA,
  digitize: DIGITIZE_PAGE_DATA,
  tapeTransfer: TAPE_TRANSFER_PAGE_DATA,
  photoScan: PHOTO_SCAN_PAGE_DATA,
  filmTransfer: FILM_TRANSFER_PAGE_DATA,
  audioTransfer: AUDIO_TRANSFER_PAGE_DATA,
  digitalTransfer: DIGITAL_TRANSFER_PAGE_DATA,
  vhs: VHS_PAGE_DATA,
  vhsC: VHS_C_PAGE_DATA,
  hi8: HI8_PAGE_DATA,
  miniDV: MINI_DV_PAGE_DATA,
  betamax: BETAMAX_PAGE_DATA,
  proFormat: PRO_FORMAT_PAGE_DATA,
  loosePhotos: LOOSE_PHOTOS_PAGE_DATA,
  slides: SLIDES_PAGE_DATA,
  negatives: NEGATIVES_PAGE_DATA,
  photoAlbums: PHOTO_ALBUMS_PAGE_DATA,
  documentScanning: DOCUMENT_SCANNING_PAGE_DATA,
  film8mm: FILM_8MM_PAGE_DATA,
  filmSuper8mm: FILM_SUPER_8MM_PAGE_DATA,
  film16mm: FILM_16MM_PAGE_DATA,
};

export {
  HOME_PAGE_DATA,
  DIGITIZE_PAGE_DATA,
  TAPE_TRANSFER_PAGE_DATA,
  PHOTO_SCAN_PAGE_DATA,
  FILM_TRANSFER_PAGE_DATA,
  AUDIO_TRANSFER_PAGE_DATA,
  DIGITAL_TRANSFER_PAGE_DATA,
  VHS_PAGE_DATA,
  VHS_C_PAGE_DATA,
  HI8_PAGE_DATA,
  MINI_DV_PAGE_DATA,
  BETAMAX_PAGE_DATA,
  PRO_FORMAT_PAGE_DATA,
  LOOSE_PHOTOS_PAGE_DATA,
  SLIDES_PAGE_DATA,
  NEGATIVES_PAGE_DATA,
  PHOTO_ALBUMS_PAGE_DATA,
  DOCUMENT_SCANNING_PAGE_DATA,
  FILM_8MM_PAGE_DATA,
  FILM_SUPER_8MM_PAGE_DATA,
  FILM_16MM_PAGE_DATA,
  PAGES_DATA,
};

export default PAGES_DATA;
